import {
  CurrentUserOrganizationDto,
  PermissionDto,
  OrganizationDto,
} from '@sib/api';
import { create, StateCreator } from 'zustand';
import { createJSONStorage, persist, StateStorage } from 'zustand/middleware';
import {
  customExtensionStorage,
  shouldUseExtensionStorage,
} from './extension-storage';

const USER_SETUP_STORE_STORAGE_KEY = 'user-setup.store';

interface UserSetupStore {
  organizationId: string;
  userRoles: string[];
  organizations: CurrentUserOrganizationDto[];
  // TODO: transform into one organization object
  organizationName: string;
  setOrganizationName: (id: string) => void;
  setOrganizationId: (id: string) => void;
  clearOrganizationId: () => void;
  setOrganizations: (organizations: CurrentUserOrganizationDto[]) => void;
  setUserRoles: (roles: string[]) => void;
  userPermissions: PermissionDto[];
  setUserPermissions: (permissions: PermissionDto[]) => void;
  parentOrganization: OrganizationDto | null;
  setParentOrganization: (org: OrganizationDto | null) => void;
  entryPointOrganization: OrganizationDto | null;
  setEntryPointOrganization: (org: OrganizationDto | null) => void;
}

const stateCreator: StateCreator<UserSetupStore> = set => ({
  organizationId: '',
  userRoles: [],
  organizations: [],
  userPermissions: [],
  setOrganizationId: (id: string) => {
    set({ organizationId: id });
  },
  organizationName: '',
  setOrganizationName: (name: string) => {
    set({ organizationName: name });
  },
  clearOrganizationId: () => set({ organizationId: '' }),
  setUserRoles: (roles: string[]) => set({ userRoles: roles }),
  setOrganizations: (organizations: CurrentUserOrganizationDto[]) =>
    set({ organizations }),
  setUserPermissions: (permissions: PermissionDto[]) =>
    set({ userPermissions: permissions }),
  parentOrganization: null,
  setParentOrganization: (org: OrganizationDto | null) =>
    set({ parentOrganization: org }),
  entryPointOrganization: null,
  setEntryPointOrganization: (org: OrganizationDto | null) =>
    set({ entryPointOrganization: org }),
});

export const useUserSetupStore = create<UserSetupStore>()(
  persist(stateCreator, {
    name: USER_SETUP_STORE_STORAGE_KEY,
    storage: createJSONStorage(() =>
      shouldUseExtensionStorage
        ? (customExtensionStorage as StateStorage)
        : localStorage
    ),
  })
);
